module.exports = __webpack_public_path__ + "assets/webgl/section_3.a9107b9d.glb";